module.exports = __webpack_public_path__ + "static/media/bh_project_ilus.4ee7d0aa.jpg";